import Logger from '../logger';
import KrempRules from './krempRules';

const DAY_IN_MILLISECONDS = 86400000;
const MILLISECONDS_PER_MINUTE = 60000;

const evaluateByZone = (opt, zip, isDomestic) => {
  let applies = false
  switch (opt.zone) {
    case 'By Zip Codes':
      if (opt.zipCodes && opt.zipCodes.includes(zip)) {
        applies = true;
      }
      break;

    case 'By Zip Code Range':
      const zipAsNum = parseInt(zip);
      if (opt.zipCodeRangeStart && opt.zipCodeRangeEnd) {
        applies = zipAsNum >= opt.zipCodeRangeStart && zipAsNum <= opt.zipCodeRangeEnd;
        /* console.log(opt, zip, 'By Zip Code Range', 'applies', applies); */
      }
      break;

    case 'Domestic':
      if (isDomestic) {
        applies = true;
      }
      break;

    case 'International':
      if (!isDomestic) {
        applies = true;
      }
      break;
  
    default:
      break;
  }
  return applies;
}

const evaluateByQuantity = (opt, quantity) => {
  return quantity >= opt.quantityRangeStart && quantity <= opt.quantityRangeEnd;
}

const evaluateByBoxSize = (opt, boxSize) => {
  console.log('boxSize', boxSize, 'opt.boxSize', opt.boxSize);
  return boxSize === opt.boxSize;
}

const evaluateAndFilter = (shippingOptions, {boxSize, quantity, zip}, isDomestic) => {
  let appliedOptions = shippingOptions.filter(opt => {
    let applies = false;
    switch (opt.evaluationType) {
      case 'Box Size':
        applies = evaluateByZone(opt, zip, isDomestic) && evaluateByBoxSize(opt, boxSize);
        break;

      case 'Only by Zone':
        applies = evaluateByZone(opt, zip, isDomestic);
        break;

        case 'Quantity Range':
        applies = evaluateByZone(opt, zip, isDomestic) && evaluateByQuantity(opt, quantity);
        break;
    
      default:
        break;
    }
    return applies;
  })
  //
  const evalTypes = new Set(appliedOptions.map(opt => opt.evaluationType));
  const zones = new Set(appliedOptions.map(opt => opt.zone));
  if (evalTypes.has('Only by Zone') && (zones.has('By Zip Codes') || zones.has('By Zip Code Range'))) {
    appliedOptions = appliedOptions.filter(opt => opt.zone !== 'Domestic');
  }
  return appliedOptions;
}

const filterByShipDate = (zip, shippingOptions, deliveryDate, pastSameDayCutOff) => {
  return shippingOptions.filter(opt => {
    if (opt.shipDate && opt.shipDate < 0) {
      const zipData = KrempRules.getDomesticZipData(zip);
      const localeStr = new Date(deliveryDate).toLocaleString('en-US', { timeZone: zipData.timezone });
      const deliveryTime = new Date(localeStr).setHours(12, 0, 0, 0);
      let shippingDate = new Date(deliveryTime + (DAY_IN_MILLISECONDS * opt.shipDate));
      if (shippingDate.getDay() === 0) {
        /* if shippingDate === Sunday */
        shippingDate = new Date(shippingDate.getTime() - DAY_IN_MILLISECONDS);
      }
      const shipTime = shippingDate.getTime();
      const today = new Date().setHours(12, 0, 0, 0);
      /* const tomorrow = today + (DAY_IN_MILLISECONDS); */
      /* console.log(new Date(today), new Date(tomorrow), deliveryDate); */
      if (shipTime === today) {
        return !pastSameDayCutOff;
      /* } else if (deliveryTime === tomorrow && pastSameDayCutOff) {
        return false */
      } else if ((shipTime < today) || (shipTime > deliveryTime)) {
        return false;
      }
    }
    return true;
  });
}

const getProperties = () => {
  let boxSize = document.querySelector('input[name="properties[_box_size]"]')?.value;
  if (!boxSize) {
    const arr = Array.from(document.querySelectorAll('[data-box-size]')).map(el => el.dataset.boxSize);
    if (arr.length) boxSize = arr.reduce((a,b) => a && a !== '' ? a : b)
  }
  return {
    boxSize,
    quantity: parseInt(document.querySelector('input[name="quantity"]')?.value || document.querySelector('.header__cart-count-number')?.textContent),
    shipType: document.querySelector('input[name="properties[_shipping_type]"]')?.value || document.querySelector('input[name="attributes[shippingType]"]')?.value,
    zip: document.querySelector('#zipCodeInput').value
  }
}

const getPastSameDayCutOff = (rules, zip, dateStr) => {
  let b = false;
  const cutoffRule = rules ? rules.find(r => r.type === 'shipping cutoff') : null;
  if (cutoffRule) {
    b = KrempRules.isAfterCutOffTimeInZipCode(zip, dateStr, cutoffRule.time);
  }
  return b
}

export default class ShippingRates {
  NAME = 'ShippingRates'
  flatpickr
  rules

  constructor(flatpickr, rules) {
    Logger.info(`${this.NAME} > constructor`, 'rules', rules);
    this.flatpickr = flatpickr;
    this.rules = rules;
    this.flatpickr.config.onOpen.push(() => this.addRates());
    this.flatpickr.config.onMonthChange.push(() => this.addRates());
  }

  addRates() {
    Logger.info(`${this.NAME} > addRates`);
    const properties = getProperties();
    Logger.info(`${this.NAME} > addRates > properties`, properties);
    if (properties.zip && properties.zip !== '') {
      const zipAsNum = parseInt(properties.zip);
      const options = evaluateAndFilter(
        window.shippingOptions.filter(opt => opt.shipType === properties.shipType), 
        properties,
        KrempRules.zipCodeIsDomestic(zipAsNum)
      );
      Logger.info(`${this.NAME} > addRates > options`, options);
      const dayEls = document.querySelectorAll('.flatpickr-day:not(.flatpickr-disabled):not(.nextMonthDay)');
      let appliedOptions, isSaturday, price, pastSameDayCutOff, dateStr;
      dayEls.forEach(el => {
        dateStr = el.getAttribute('aria-label');
        pastSameDayCutOff = getPastSameDayCutOff(this.rules, zipAsNum, dateStr) 
        appliedOptions = filterByShipDate(zipAsNum, options, dateStr, pastSameDayCutOff);
        Logger.info(`${this.NAME} > addRates > date: ${dateStr} > appliedOptions`, appliedOptions);
        if (appliedOptions.length) {
          isSaturday = new Date(dateStr).getDay() === 6;
          price = appliedOptions.map(opt => isSaturday ? (opt.saturdayDeliveryCharge ? parseFloat(opt.saturdayDeliveryCharge.amount) + parseFloat(opt.price.amount) : parseFloat(opt.price.amount)) : parseFloat(opt.price.amount))
                        .reduce((a,b) => a < b ? a : b, 100000);
          el.dataset.rate = `$${price}`;
        }
      })
      
    }
  }
  
}
